var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0037 16 0.0018125 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C15.9991 0 15.9982 6.25e-05 15.9973 6.25e-05L16 0Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.0001H16.0001C16.0001 15.9856 16.0001 15.9717 16.0001 15.9573C15.9858 15.9716 15.9716 15.9858 15.9573 16.0001Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34879C16 5.53348 16 3.68866 16 0.000976562H15.9973C7.162 0.00241406 0 7.16523 0 16.0009H8.34781V11.3002L13.0486 16.0009H15.9572C15.9716 15.9867 15.9858 15.9724 16.0001 15.9581C16.0001 14.8802 16.0001 13.9184 16.0001 13.0496L11.2992 8.34879H16Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.08691C5.5921 3.51185 3.51173 5.59223 2.08679 8.09466V16H6.26073V6.26091V6.26085H15.9999C15.9999 4.94441 15.9999 3.69029 15.9999 2.08691H8.09454Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0324L10.3155 8.34793H8.3479C8.3479 8.34787 8.3479 8.34793 8.3479 8.34793L16 16H16C16 16 16 14.6434 16 14.0324Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64972 18.7827L10.5278 20.6188L12.5108 20.1605L11.6228 21.9918L13.2174 23.2564L11.232 23.7039L11.2375 25.7392L9.64972 24.4658L8.06197 25.7392L8.06753 23.7039L6.08203 23.2564L7.67672 21.9918L6.78859 20.1605L8.77166 20.6188L9.64972 18.7827Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9552 22.2609L24.3943 23.179L25.3858 22.9498L24.9417 23.8655L25.7391 24.4978L24.7463 24.7215L24.7491 25.7392L23.9552 25.1025L23.1613 25.7392L23.1641 24.7215L22.1714 24.4978L22.9687 23.8655L22.5247 22.9498L23.5161 23.179L23.9552 22.2609Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8708 12.5219L20.3098 13.44L21.3013 13.2107L20.8573 14.1264L21.6546 14.7587L20.6619 14.9825L20.6646 16.0001L19.8708 15.3634L19.0769 16.0001L19.0796 14.9825L18.0869 14.7587L18.8842 14.1264L18.4402 13.2107L19.4317 13.44L19.8708 12.5219Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9552 6.95654L24.3943 7.87467L25.3858 7.64548L24.9418 8.56117L25.739 9.19342L24.7463 9.41723L24.7491 10.4349L23.9552 9.79817L23.1613 10.4349L23.1641 9.41723L22.1714 9.19342L22.9686 8.56117L22.5247 7.64548L23.5161 7.87467L23.9552 6.95654Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5229 11.1305L27.9619 12.0486L28.9534 11.8194L28.5094 12.7351L29.3067 13.3674L28.314 13.5912L28.3167 14.6087L27.5229 13.9721L26.729 14.6087L26.7317 13.5912L25.739 13.3674L26.5363 12.7351L26.0923 11.8194L27.0838 12.0486L27.5229 11.1305Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9718 16L25.3172 17.0629H26.4348L25.5306 17.7198L25.876 18.7826L24.9718 18.1257L24.0677 18.7826L24.413 17.7198L23.5089 17.0629H24.6265L24.9718 16Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.fb92bb14.svg";
export { ForwardRef as ReactComponent };